// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import scriptLoadingHelper from '../script-loading-helper';
import Cookies from 'js-cookie';

/** Async load Drift script IF: PWS and OneTrust have finished loading Drift is enabled in tracking config */
const driftHelper = {
  permissions: {} as InitializationProperties,

  initialize: (permissions: InitializationProperties): Promise<void> => {
    driftHelper.permissions = permissions;
    driftHelper.load();
  },

  load: () => {
    if (driftHelper.permissions.advertisingTrackingEnabled) {
      driftHelper.loadScript();
    }

    window.addEventListener('consent.onetrust', () => {
      if (!driftHelper.permissions.advertisingTrackingEnabled) {
        driftHelper.unload();
      }
    });
  },

  // Adds external Drift script to page and performs necessary instantiation
  loadScript: () => {
    if (document.getElementById('drift-script-tag')) {
      return;
    }

    // Ugliness adapted as required from Drift-provided snippet
    const drift = (window.driftt = window.drift = window.driftt || []);

    drift.methods = ['identify', 'config', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on'];

    // Makes src path changes every time we insert the script, so it's never stale
    const roundedDate = Math.ceil(Date.now() / 3e5) * 3e5;

    const src = `https://js.driftt.com/include/${roundedDate}/mshc9skt2uyu.js`; // TODO: PWB-1148 refactor the config

    scriptLoadingHelper.injectClientScript('drift-script-tag', src, 'lazyOnload', {
      async: true,
      onLoad: driftHelper.onLoad,
    });
  },

  onLoad: () => {
    driftHelper.setContactInfo({
      Square_AVT__c: Cookies.get('_savt'),
      recent_entrance_page_url: document.location.href.split('?')[0],
    });
    driftHelper.setCDPTracking();
  },

  // Usage: Updates or creates a new contact in Drift
  // Input - Object where:
  //    keys = name of some contact attribute in Drift (usually form field name)
  //    values = what to assign to that attribute
  //      NOTE - for custom attributes, key must be snake case to properly associate
  //      See: https://devdocs.drift.com/docs/data-types-in-drift#setting-up-new-custom-attributes
  //    Example input - {email: 'ethans@squareup.com', company: 'block'}
  //
  // If the attribute does not already exist in Drift, Drift will automatically create it
  // If an existing related contact cannot be found (based on email and/or cookies), Drift will create a new one
  //   NOTE - Drift can only create a new contact if at least email is provided
  //
  // Additional docs: https://devdocs.drift.com/docs/contact-properties#driftapisetuserattributesattributes
  setContactInfo: (attributes) => {
    if (window.drift) {
      if (window.drift.api && typeof window.drift.api.setUserAttributes === 'function') {
        window.drift.api.setUserAttributes(attributes);
      } else if (typeof window.drift.on === 'function') {
        window.drift.on('ready', function () {
          window.drift.api.setUserAttributes(attributes);
        });
      }
    }
  },

  setCDPTracking: () => {
    if (driftHelper.permissions.advertisingTrackingEnabled && window.drift && typeof window.drift.on === 'function') {
      window.drift.on('startConversation', (data) => {
        window.Sq.Tracking.track({ action: 'Conversation Started', properties: data }, { destinations: ['cdp'] });
      });
      window.drift.on('scheduling:meetingBooked', (data) => {
        window.Sq.Tracking.track({ action: 'Meeting Booked', properties: data }, { destinations: ['cdp'] });
      });
      window.drift.on('conversation:playbookFired', (data) => {
        window.Sq.Tracking.track({ action: 'Playbook Fired', properties: data }, { destinations: ['cdp'] });
      });
      window.drift.on('conversation:playbookClicked', (data) => {
        window.Sq.Tracking.track({ action: 'Playbook Clicked', properties: data }, { destinations: ['cdp'] });
      });
    }
  },

  unload: () => {
    if (window.drift) {
      // Drift's built-in unload wipes script, cookies, and session storage
      window.drift.unload();
    }

    // We wipe local storage items ourselves
    localStorage.removeItem('DRIFT_visitCounts');
    localStorage.removeItem('DRIFT_isChatFrameOpen');
    localStorage.removeItem('DRIFT_SESSION_CAMPAIGNS');
    localStorage.removeItem('DRIFT_openTabs');
  },
};

export default driftHelper;
